// src/components/Modules.js

import React, { useState, useEffect } from "react";
import { Layout, theme } from "antd";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../Sidebar";
import HeaderComponent from "../Header";
import Footer from "../Footer";
import "./Modules.css"; // Importa el CSS
import AnnouncementBanner from "../AnnouncementBanner";
import ModuleGuard from "./ModuleGuard";
import useAutoReconnect from "../../hooks/useAutoReconnect";
// Importa tus componentes de rutas aquí
import Patients from "./patients/Patients";
import Authorizations from "./Authorizations/Authorizations";
import UserList from "./UserList/UserList";
import UserCards from "./UserCards/UserCards";
import Clients from "./clients/Clients";
import Drivers from "./Drivers/Drivers";
import Vehicles from "./Vehicles/Vehicles";
import TimeCheck from "./TimeCheck";
import VehiculoConductores from "./Assignments/VehiculoConductores";
import Institutions from "./Institutions/Institutions";
import CenterControl from "./CenterControl/CenterControl";
import Coordinacion from "./Coordinacion/Coordinacion";
import ControlServiciosIndex from "./ControlServicios/ControlServiciosIndex";

import List from "../modules/PreOperations/List";
import Response from "../modules/PreOperations/Response";

import Dashboard from "./Dashboard/Dashboard";
import Transportadoras from "./Transportadoras/Transportadoras";
import TAI from "./TAI/TAI";
import PlanillasTAI from "./TAI/PlanillasTAI";
import TAIEstadisticas from "./TAI/TAIEstadisticas";

import EditarRol from "./Rol/pages/EditarRol";
import RolesList from "./Rol/pages/RolesList";
import Configuraciones from "./Configuraciones/Configuraciones";

// FUEC Module
import { FuecList, FuecConfig, ObjetosContrato } from "./Fuec";

const { Content } = Layout;

function Modules() {
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const toggleDrawer = () => setOpen(!open);
  
  // Hook para manejar reconexión automática del WebSocket
  useAutoReconnect();

  // Detectar si el dispositivo es móvil
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // Define marginLeft usando una lógica clara sin ternarios anidados
  let calculatedMarginLeft = 0;
  if (!isMobile) {
    calculatedMarginLeft = open ? 250 : 80;
  }

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Sidebar open={open} toggleDrawer={toggleDrawer} />

      <Layout
        className="site-layout"
        style={{
          marginLeft: calculatedMarginLeft, // Uso de la variable calculada
          transition: "all 0.2s",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <HeaderComponent toggleSidebar={toggleDrawer} />
        <AnnouncementBanner />

        <Content
          style={{
            margin: "16px",
            padding: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <div
            style={{
              padding: 24,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              flex: 1,
              overflow: "auto",
            }}
          >
            <Routes>
              <Route path="Dashboard" element={<Dashboard />} />
              <Route
                path="UserList"
                element={
                  <ModuleGuard moduleKey="Usuarios">
                    <UserList />
                  </ModuleGuard>
                }
              />
              <Route
                path="UserCards"
                element={
                  <ModuleGuard moduleKey="Usuarios">
                    <UserCards />
                  </ModuleGuard>
                }
              />
              <Route
                path="Patients"
                element={
                  <ModuleGuard moduleKey="Pacientes">
                    <Patients />
                  </ModuleGuard>
                }
              />
              <Route
                path="Authorizations"
                element={
                  <ModuleGuard moduleKey="Autorizaciones">
                    <Authorizations />
                  </ModuleGuard>
                }
              />
              <Route
                path="Clients"
                element={
                  <ModuleGuard moduleKey="Clientes">
                    <Clients />
                  </ModuleGuard>
                }
              />
              <Route
                path="Drivers"
                element={
                  <ModuleGuard moduleKey="Transporte">
                    <Drivers />
                  </ModuleGuard>
                }
              />
              <Route
                path="Vehicles"
                element={
                  <ModuleGuard moduleKey="Transporte">
                    <Vehicles />
                  </ModuleGuard>
                }
              />
              <Route
                path="VehiculoConductores"
                element={
                  <ModuleGuard moduleKey="Transporte">
                    <VehiculoConductores />
                  </ModuleGuard>
                }
              />
              <Route path="TimeCheck" element={<TimeCheck />} />
              <Route
                path="Institutions"
                element={
                  <ModuleGuard moduleKey="Instituciones">
                    <Institutions />
                  </ModuleGuard>
                }
              />
              <Route
                path="CenterControl"
                element={
                  <ModuleGuard moduleKey="Centro de Control">
                    <CenterControl />
                  </ModuleGuard>
                }
              />
              <Route
                path="Coordinacion"
                element={
                  <ModuleGuard moduleKey="Coordinacion">
                    <Coordinacion />
                  </ModuleGuard>
                }
              />
              <Route
                path="ControlServicios"
                element={
                  <ModuleGuard moduleKey="Control Servicios">
                    <ControlServiciosIndex />
                  </ModuleGuard>
                }
              />
              <Route
                path="Transportadoras"
                element={
                  <ModuleGuard moduleKey="Transportadoras">
                    <Transportadoras />
                  </ModuleGuard>
                }
              />
              <Route
                path="TAI"
                element={
                  <ModuleGuard moduleKey="TAI">
                    <TAI />
                  </ModuleGuard>
                }
              />
              <Route
                path="PlanillasTAI"
                element={
                  <ModuleGuard moduleKey="TAI">
                    <PlanillasTAI />
                  </ModuleGuard>
                }
              />
              <Route
                path="TAIEstadisticas"
                element={
                  <ModuleGuard moduleKey="TAI">
                    <TAIEstadisticas />
                  </ModuleGuard>
                }
              />
              {/* FUEC Module Routes */}
              <Route
                path="Fuec"
                element={
                  <ModuleGuard moduleKey="FUEC">
                    <FuecList />
                  </ModuleGuard>
                }
              />
              <Route
                path="FuecConfig"
                element={
                  <ModuleGuard moduleKey="FUEC">
                    <FuecConfig />
                  </ModuleGuard>
                }
              />
              <Route
                path="ObjetosContrato"
                element={
                  <ModuleGuard moduleKey="FUEC">
                    <ObjetosContrato />
                  </ModuleGuard>
                }
              />

              <Route path="Configuraciones" element={<Configuraciones />} />

              <Route path="roles">
                <Route
                  index
                  element={
                    <ModuleGuard moduleKey="Usuarios">
                      <RolesList />
                    </ModuleGuard>
                  }
                />
                <Route
                  path="editar/:id"
                  element={
                    <ModuleGuard moduleKey="Usuarios">
                      <EditarRol key="edit" />
                    </ModuleGuard>
                  }
                />
                <Route
                  path="nuevo"
                  element={
                    <ModuleGuard moduleKey="Usuarios">
                      <EditarRol key="new" />
                    </ModuleGuard>
                  }
                />
              </Route>

              <Route path="/" element={<div>Seleccione una opción</div>} />
              <Route
                path="preoperations"
                element={
                  <ModuleGuard moduleKey="Transporte">
                    <List />
                  </ModuleGuard>
                }
              />
              <Route
                path="preoperations/respond/:conductorId/:vehiculoId"
                element={
                  <ModuleGuard moduleKey="Transporte">
                    <Response />
                  </ModuleGuard>
                }
              />
            </Routes>
          </div>
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Modules;
